import { useState } from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import AboutSection from './components/AboutSection';
import GolfSection from './components/GolfSection';
import FleetSection from './components/FleetSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import ReservationSection from './components/ReservationSection';
import Footer from './components/Footer';

export default function Home() {
  const [isReservationModalOpen, setIsReservationModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navigation onOpenReservation={() => setIsReservationModalOpen(true)} />
      <HeroSection />
      <ServicesSection />
      <PricingSection />
      <AboutSection />
      <GolfSection />
      <FleetSection />
      <TestimonialsSection />
      <ContactSection />
      <ReservationSection 
        isModalOpen={isReservationModalOpen}
        onCloseModal={() => setIsReservationModalOpen(false)}
      />
      <Footer />
    </div>
  );
}